import React from 'react';
import { connect } from 'react-redux';

import Header from './header/header';
import Content from './content/content';
import Footer from './footer/footer';

//import 'bootstrap/dist/css/bootstrap.css';
import '../../assets/front/css/index.css';

const FrontLayout = props => {

    document.querySelector('body').style.background = "#fff";

    return (
        <main>
            <Header />
            <Content children={props.children} />
            <Footer />
        </main>
    )
}

export default connect(state => state, null)(FrontLayout);


// WEBPACK FOOTER //
// ./src/components/front/frontLayout.js